import { render } from "./App.vue?vue&type=template&id=2bcd0c0c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2bcd0c0c&lang=css"

import exportComponent from "E:\\三星门店查询\\samsung-store-locator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__